/**
 * @remarks Reviewers should confirm loading, error, and i18n paths when modifying this file.
 * @remarks Contributors should run client tests and production build before opening a PR.
 * @see Sonar quality gate — maintain comment density and low cyclomatic complexity.
 */
/**
 * @description Maintainability notes for Sonar and future contributors:
 * - Prefer small functions and hooks over monolithic components.
 * - Extract shared literals, styles, and helpers instead of copying blocks.
 * - Document non-obvious business rules with short comments or JSDoc tags.
 * - Keep API access in logic/ modules; keep UI state in hooks/components.
 * - Use stable React keys and memoized handlers in list-heavy views.
 * - Add or update unit tests when changing conditional flows or payments.
 */
/**
 * @fileoverview Client module `PasswordSuccess` for the Caintra Connect frontend.
 * @module pages/PasswordSuccess
 *
 * Conventions:
 * - Keep components focused on rendering; move branching logic into hooks or utils.
 * - Prefer named exports for helpers and default exports for React components.
 * - Reuse shared validation, i18n, and API helpers from client/src/utils and logic/.
 */
import { useEffect } from "react";
import { useNavigate } from "react-router";
import { useTranslation } from "react-i18next";

import styles from "../styles/PasswordSuccess.module.css";
import Caintra_Logo from "../assets/Caintra_Logo.png";
import LanguageSelector from "../components/LanguageSelector/index.jsx";

const PasswordRecovery = () => {
  const { t } = useTranslation();
  const navigate = useNavigate();

  useEffect(() => {
    setTimeout(() => {
      navigate("/");
    }, 3000);
  }, []);

  return (
    <div className={styles.container}>
      <div className={styles.header}>
        <LanguageSelector />
      </div>
      <div className={styles.imgContainer}>
        <img src={Caintra_Logo} alt="" />
      </div>
      <div className={styles.mainContainer}>
        <div>
          <span className={styles.title}>
            {t("pages.successPassword.header")}
          </span>
        </div>
        <div className={styles.contentWrapper}>
          <div className={styles.textContainer}>
            <span className={styles.subtitle}>
              {t("pages.successPassword.subtitle")}
            </span>
          </div>
        </div>
      </div>
    </div>
  );
};

export default PasswordRecovery;
